var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 896 l-28 -24 -3 -367 -3 -366 30 -29 29 -30 279 0 c159 0 284 4 293 10 23 14 -166 203 -190 190 -73 -39 -178 -25 -235 30 -46 45 -65 88 -65 149 0 212 284 278 381 89 24 -46 25 -128 2 -175 l-16 -35 79 -79 c43 -43 82 -79 86 -79 5 0 8 109 8 243 l0 242 -128 128 -127 127 -182 0 c-178 0 -183 -1 -210 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 575 c-39 -17 -63 -52 -70 -103 -18 -134 166 -195 237 -79 38 61 14 145 -50 179 -41 21 -73 22 -117 3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverGigs);
export default __webpack_public_path__ + "static/media/DiscoverGigs.42d27eaa.svg";
export { ForwardRef as ReactComponent };